import {useState, useEffect} from "react";
import {HubConnectionBuilder} from "@microsoft/signalr";
import {connect} from "react-redux";
import {BROWSER_SIGNALR_URL} from "util/RestClient";
import {loginUserAction} from "redux/actions/login-actions";

export default function BrowserSignalR(props) {
	const [connection, setConnection] = useState(null);
	const credentials = props.credentials;
	useEffect(() => {
		const newConnection = new HubConnectionBuilder().withUrl(BROWSER_SIGNALR_URL).withAutomaticReconnect().build();
		setConnection(newConnection);
	}, []);

	useEffect(() => {
		if (connection) {
			connection
				.start()
				.then((result) => {
					connection.on("TryLogin", () => {
						props.loginUser(credentials);
						setConnection(null);
					});
				})
				.catch((e) => console.error("Connection failed: ", e));
		}
	}, [connection]);

	return null;
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
	loginUser: (credentials) => {
		dispatch(loginUserAction(credentials));
	},
});

BrowserSignalR = connect(mapStateToProps, mapDispatchToProps)(BrowserSignalR);
